import { SKIPPED, elapsed, createValueHistory, SESSION_TIME_OUT_DELAY, toServerDuration, addEventListeners, relativeNow } from '@datadog/browser-core';
import { supportPerformanceTimingEvent, RumPerformanceEntryType } from '../../browser/performanceObservable';
import { RumEventType } from '../../rawRumEvent.types'; // Arbitrary value to cap number of element for memory consumption in the browser

export var MAX_PAGE_STATE_ENTRIES = 4000; // Arbitrary value to cap number of element for backend & to save bandwidth

export var MAX_PAGE_STATE_ENTRIES_SELECTABLE = 500;
export var PAGE_STATE_CONTEXT_TIME_OUT_DELAY = SESSION_TIME_OUT_DELAY;
export function startPageStateHistory(hooks, configuration) {
  var maxPageStateEntriesSelectable = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : MAX_PAGE_STATE_ENTRIES_SELECTABLE;
  var pageStateEntryHistory = createValueHistory({
    expireDelay: PAGE_STATE_CONTEXT_TIME_OUT_DELAY,
    maxEntries: MAX_PAGE_STATE_ENTRIES
  });
  var currentPageState;

  if (supportPerformanceTimingEvent(RumPerformanceEntryType.VISIBILITY_STATE)) {
    var visibilityEntries = performance.getEntriesByType(RumPerformanceEntryType.VISIBILITY_STATE);
    visibilityEntries.forEach(function (entry) {
      var state = entry.name === 'hidden' ? "hidden"
      /* PageState.HIDDEN */
      : "active"
      /* PageState.ACTIVE */
      ;
      addPageState(state, entry.startTime);
    });
  }

  addPageState(getPageState(), relativeNow());

  var _addEventListeners = addEventListeners(configuration, window, ["pageshow"
  /* DOM_EVENT.PAGE_SHOW */
  , "focus"
  /* DOM_EVENT.FOCUS */
  , "blur"
  /* DOM_EVENT.BLUR */
  , "visibilitychange"
  /* DOM_EVENT.VISIBILITY_CHANGE */
  , "resume"
  /* DOM_EVENT.RESUME */
  , "freeze"
  /* DOM_EVENT.FREEZE */
  , "pagehide"
  /* DOM_EVENT.PAGE_HIDE */
  ], function (event) {
    addPageState(computePageState(event), event.timeStamp);
  }, {
    capture: true
  }),
      stopEventListeners = _addEventListeners.stop;

  function addPageState(nextPageState) {
    var startTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : relativeNow();

    if (nextPageState === currentPageState) {
      return;
    }

    currentPageState = nextPageState;
    pageStateEntryHistory.closeActive(startTime);
    pageStateEntryHistory.add({
      state: currentPageState,
      startTime: startTime
    }, startTime);
  }

  function wasInPageStateDuringPeriod(state, startTime, duration) {
    return pageStateEntryHistory.findAll(startTime, duration).some(function (pageState) {
      return pageState.state === state;
    });
  }

  hooks.register(0
  /* HookNames.Assemble */
  , function (_ref) {
    var startTime = _ref.startTime,
        _ref$duration = _ref.duration,
        duration = _ref$duration === void 0 ? 0 : _ref$duration,
        eventType = _ref.eventType;

    if (eventType === RumEventType.VIEW) {
      var pageStates = pageStateEntryHistory.findAll(startTime, duration);
      return {
        type: eventType,
        _dd: {
          page_states: processPageStates(pageStates, startTime, maxPageStateEntriesSelectable)
        }
      };
    }

    if (eventType === RumEventType.ACTION || eventType === RumEventType.ERROR) {
      return {
        type: eventType,
        view: {
          in_foreground: wasInPageStateDuringPeriod("active"
          /* PageState.ACTIVE */
          , startTime, 0)
        }
      };
    }

    return SKIPPED;
  });
  return {
    wasInPageStateDuringPeriod: wasInPageStateDuringPeriod,
    addPageState: addPageState,
    stop: function stop() {
      stopEventListeners();
      pageStateEntryHistory.stop();
    }
  };
}

function processPageStates(pageStateEntries, eventStartTime, maxPageStateEntriesSelectable) {
  if (pageStateEntries.length === 0) {
    return;
  }

  return pageStateEntries.slice(-maxPageStateEntriesSelectable).reverse().map(function (_ref2) {
    var state = _ref2.state,
        startTime = _ref2.startTime;
    return {
      state: state,
      start: toServerDuration(elapsed(eventStartTime, startTime))
    };
  });
}

function computePageState(event) {
  if (event.type === "freeze"
  /* DOM_EVENT.FREEZE */
  ) {
    return "frozen"
    /* PageState.FROZEN */
    ;
  } else if (event.type === "pagehide"
  /* DOM_EVENT.PAGE_HIDE */
  ) {
    return event.persisted ? "frozen"
    /* PageState.FROZEN */
    : "terminated"
    /* PageState.TERMINATED */
    ;
  }

  return getPageState();
}

function getPageState() {
  if (document.visibilityState === 'hidden') {
    return "hidden"
    /* PageState.HIDDEN */
    ;
  }

  if (document.hasFocus()) {
    return "active"
    /* PageState.ACTIVE */
    ;
  }

  return "passive"
  /* PageState.PASSIVE */
  ;
}